var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Tables")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("The "), _c('code', [_vm._v(".table ")]), _vm._v(" class adds basic styling to a table.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-1"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\"></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Table Head Options")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Similar to tables and dark tables, use the modifier classes "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".thead-light")]), _vm._v(" or "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".thead-dark")]), _vm._v(" to make "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v("<thead>")]), _vm._v("s appear light or dark gray.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-2"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\" head-variant=\"dark\"></b-table>\n<b-table :items=\"items\" head-variant=\"light\"></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "head-variant": "dark"
          }
        }), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "head-variant": "light"
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Borderless table")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Add "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-borderless")]), _vm._v(" for a table without borders.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-3"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\" borderless></b-table>\n<p><code class=\"highlighter-rouge\">.table-borderless</code> can also be used on dark tables.</p>\n<b-table :items=\"items\" table-variant=\"dark\" borderless></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "borderless": ""
          }
        }), _c('p', [_c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-borderless")]), _vm._v(" can also be used on dark tables.")]), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "table-variant": "dark",
            "borderless": ""
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Small table")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Add "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-sm")]), _vm._v(" to make tables more compact by cutting cell padding in half.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-4"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table small :items=\"items\"></b-table>\n<b-table small :items=\"items\" table-variant=\"dark\"></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "small": "",
            "items": _vm.items
          }
        }), _c('b-table', {
          attrs: {
            "small": "",
            "items": _vm.items,
            "table-variant": "dark"
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Captions")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("A "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v("<caption>")]), _vm._v(" functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-5"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\">\n  <template v-slot:table-caption>List of users</template>\n</b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items
          },
          scopedSlots: _vm._u([{
            key: "table-caption",
            fn: function fn() {
              return [_vm._v("List of users")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Table Dark")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("You can also invert the colors—with light text on dark backgrounds—with "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-dark")]), _vm._v(".")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-6"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\" table-variant=\"dark\"></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "table-variant": "dark"
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Striped rows")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-7",
            modifiers: {
              "collapse-7": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Use "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-striped")]), _vm._v(" to add zebra-striping to any table row within the "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v("<tbody>")]), _vm._v(".")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-7"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-7"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\" striped></b-table>\n<b-table :items=\"items\" table-variant=\"dark\" striped></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "striped": ""
          }
        }), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "table-variant": "dark",
            "striped": ""
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Hoverable rows")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-8",
            modifiers: {
              "collapse-8": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Add "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-hover")]), _vm._v(" to enable a hover state on table rows within a "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v("<tbody>")]), _vm._v(".")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-8"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-8"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table :items=\"items\" hover></b-table>\n<b-table :items=\"items\" table-variant=\"dark\" hover></b-table>\n<script>\n  data () {\n    return {\n      items: [\n        { '#': '1', first: 'Mark', last: 'Otto', handle: '@mdo' },\n        { '#': '2', first: 'Jacob', last: 'Thornton', handle: '@fat' },\n        { '#': '3', first: 'Larry', last: 'the Bird', handle: '@twitter' }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "hover": ""
          }
        }), _c('b-table', {
          attrs: {
            "items": _vm.items,
            "table-variant": "dark",
            "hover": ""
          }
        })];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Contextual classes")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-9",
            modifiers: {
              "collapse-9": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Use contextual classes to color table rows or individual cells.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-9"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-9"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table-simple>\n  <b-thead>\n    <b-th>Variant</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n  </b-thead>\n  <b-tbody>\n    <b-tr variant=\"active\">\n      <b-th>Active</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>Default</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr variant=\"primary\">\n      <b-th>Primary</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr variant=\"secondary\">\n      <b-th>Secondary</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr variant=\"success\">\n      <b-th>Success</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr variant=\"danger\">\n      <b-th>Danger</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr variant=\"warning\">\n      <b-th>Warning</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr variant=\"info\">\n      <b-th>Info</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n  </b-tbody>\n</b-table-simple>\n<p>Regular table background variants are not available with the dark table, however, you may use <a href=\"https://getbootstrap.com/\" target=\"_blank\">text or background utilities</a> to achieve similar styles.</p>\n<b-table-simple table-variant=\"dark\">\n  <b-thead>\n    <b-th>#</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n  </b-thead>\n  <b-tbody>\n    <b-tr class=\"bg-primary\">\n      <b-th>1</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>2</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr class=\"bg-success\">\n      <b-th>3</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>4</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr class=\"bg-info\">\n      <b-th>5</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>6</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr class=\"bg-warning\">\n      <b-th>7</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>8</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr class=\"bg-danger\">\n      <b-th>9</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n  </b-tbody>\n</b-table-simple>\n")])])])])]), _c('b-table-simple', [_c('b-thead', [_c('b-th', [_vm._v("Variant")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")])], 1), _c('b-tbody', [_c('b-tr', {
          attrs: {
            "variant": "active"
          }
        }, [_c('b-th', [_vm._v("Active")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("Default")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          attrs: {
            "variant": "primary"
          }
        }, [_c('b-th', [_vm._v("Primary")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          attrs: {
            "variant": "secondary"
          }
        }, [_c('b-th', [_vm._v("Secondary")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b-th', [_vm._v("Success")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b-th', [_vm._v("Danger")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          attrs: {
            "variant": "warning"
          }
        }, [_c('b-th', [_vm._v("Warning")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b-th', [_vm._v("Info")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1)], 1)], 1), _c('p', [_vm._v("Regular table background variants are not available with the dark table, however, you may use "), _c('a', {
          attrs: {
            "href": "https://getbootstrap.com/",
            "target": "_blank"
          }
        }, [_vm._v("text or background utilities")]), _vm._v(" to achieve similar styles.")]), _c('b-table-simple', {
          attrs: {
            "table-variant": "dark"
          }
        }, [_c('b-thead', [_c('b-th', [_vm._v("#")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")])], 1), _c('b-tbody', [_c('b-tr', {
          staticClass: "bg-primary"
        }, [_c('b-th', [_vm._v("1")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("2")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          staticClass: "bg-success"
        }, [_c('b-th', [_vm._v("3")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("4")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          staticClass: "bg-info"
        }, [_c('b-th', [_vm._v("5")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("6")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          staticClass: "bg-warning"
        }, [_c('b-th', [_vm._v("7")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("8")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', {
          staticClass: "bg-danger"
        }, [_c('b-th', [_vm._v("9")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Responsive tables")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-10",
            modifiers: {
              "collapse-10": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Responsive tables allow tables to be scrolled horizontally with ease. Make any table responsive across all viewports by wrapping a "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table")]), _vm._v(" with "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-responsive")]), _vm._v(". Or, pick a maximum breakpoint with which to have a responsive table up to by using "), _c('code', {
          staticClass: "highlighter-rouge"
        }, [_vm._v(".table-responsive{-sm|-md|-lg|-xl}")]), _vm._v(".")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-10"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-10"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-table-simple responsive>\n  <b-thead>\n    <b-th>#</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n    <b-th>Heading</b-th>\n  </b-thead>\n  <b-tbody>\n    <b-tr>\n      <b-th>1</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>2</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n    <b-tr>\n      <b-th>3</b-th>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n      <b-td>Cell</b-td>\n    </b-tr>\n  </b-tbody>\n</b-table-simple>\n")])])])])]), _c('b-table-simple', {
          attrs: {
            "responsive": ""
          }
        }, [_c('b-thead', [_c('b-th', [_vm._v("#")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")]), _c('b-th', [_vm._v("Heading")])], 1), _c('b-tbody', [_c('b-tr', [_c('b-th', [_vm._v("1")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("2")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1), _c('b-tr', [_c('b-th', [_vm._v("3")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")]), _c('b-td', [_vm._v("Cell")])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }